'use strict';

import {apiUrl} from '../../app.api.config';

export default class OrderOczfp {
  /*@ngInject*/
  constructor($http) {
    this.$http = $http;
  }

  getDataPage = function(criteria) {
    return this.$http.post(apiUrl().API_URL + '/admin/orders/dataPage?XDEBUG_SESSION_START=PHPSTORM', criteria);
  };
  getById = function(id) {
    return this.$http.post(apiUrl().API_URL + '/admin/orders/' + id + '?XDEBUG_SESSION_START=PHPSTORM');
  };
  getCsv = function(criteria) {
    return this.$http.post(apiUrl().API_URL + '/admin/insurancePersons/getCsv?XDEBUG_SESSION_START=PHPSTORM', criteria);
  };
  getCsvOczfp = function(criteria) {
    return this.$http.post(apiUrl().API_URL + '/admin/insurancePersons/getCsvOczfp?XDEBUG_SESSION_START=PHPSTORM', criteria);
  };
  changeStatuses = function(id, request) {
    return this.$http.put(apiUrl().API_URL + '/admin/orders/insurancePersons/' + id + '/changeStatuses?XDEBUG_SESSION_START=PHPSTORM', request);
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/model/OrderOczfp.js